import {
  UserActivities,
  ActivityType,
  ActivityStatus,
} from "@nestcoinco/hyper-api-gateway-api-client";

/**
 * Mock activities shown to unsubscribed users as a teaser.
 * Each section uses realistic-looking data to preview the experience.
 */

const MOCK_THIS_WEEK: UserActivities[] = [
  {
    userId: "mock",
    type: ActivityType.TOURNAMENT,
    status: ActivityStatus.COMPLETED,
    referenceId: "mock-1",
    title: "You won",
    image:
      "https://hyper-staging.mvm.gg/thumbnails/2a67dde5-03f5-4251-bb0f-af96278c2a62.jpeg",
    description: "5HPR stake duel",
    createdAt: new Date().toISOString(),
    metadata: [
      { name: "gameName", value: "Kong Climb" },
      { name: "opponentUsername", value: "alex_92" },
      { name: "isWin", value: "true" },
      { name: "tournamentId", value: "mock-t1" },
      { name: "score", value: "2450" },
    ],
  },
  {
    userId: "mock",
    type: ActivityType.TOURNAMENT,
    status: ActivityStatus.COMPLETED,
    referenceId: "mock-2",
    title: "2nd place",
    image:
      "https://hyper-staging.mvm.gg/thumbnails/2a67dde5-03f5-4251-bb0f-af96278c2a62.jpeg",
    description: "3HPR stake duel",
    createdAt: new Date().toISOString(),
    metadata: [
      { name: "gameName", value: "Stack Tower" },
      { name: "opponentUsername", value: "pro_gamer" },
      { name: "isWin", value: "false" },
      { name: "tournamentId", value: "mock-t2" },
      { name: "score", value: "1280" },
    ],
  },
];

const MOCK_LAST_WEEK: UserActivities[] = [
  {
    userId: "mock",
    type: ActivityType.TOURNAMENT,
    status: ActivityStatus.COMPLETED,
    referenceId: "mock-3",
    title: "You won",
    image:
      "https://hyper-staging.mvm.gg/thumbnails/2a67dde5-03f5-4251-bb0f-af96278c2a62.jpeg",
    description: "10HPR stake duel",
    createdAt: new Date().toISOString(),
    metadata: [
      { name: "gameName", value: "Candy Burst" },
      { name: "opponentUsername", value: "jane_doe" },
      { name: "isWin", value: "true" },
      { name: "tournamentId", value: "mock-t3" },
      { name: "score", value: "3100" },
    ],
  },
  {
    userId: "mock",
    type: ActivityType.TOURNAMENT,
    status: ActivityStatus.COMPLETED,
    referenceId: "mock-4",
    title: "It's a tie",
    image:
      "https://hyper-staging.mvm.gg/thumbnails/2a67dde5-03f5-4251-bb0f-af96278c2a62.jpeg",
    description: "5HPR stake duel",
    createdAt: new Date().toISOString(),
    metadata: [
      { name: "gameName", value: "Kong Climb" },
      { name: "opponentUsername", value: "swift_king" },
      { name: "isWin", value: "true" },
      { name: "isTie", value: "true" },
      { name: "tournamentId", value: "mock-t4" },
      { name: "score", value: "1900" },
    ],
  },
  {
    userId: "mock",
    type: ActivityType.TOURNAMENT,
    status: ActivityStatus.COMPLETED,
    referenceId: "mock-5",
    title: "You won",
    image:
      "https://hyper-staging.mvm.gg/thumbnails/2a67dde5-03f5-4251-bb0f-af96278c2a62.jpeg",
    description: "3HPR stake duel",
    createdAt: new Date().toISOString(),
    metadata: [
      { name: "gameName", value: "Bubble Pop" },
      { name: "opponentUsername", value: "nova_x" },
      { name: "isWin", value: "true" },
      { name: "tournamentId", value: "mock-t5" },
      { name: "score", value: "4200" },
    ],
  },
];

export const MOCK_SECTIONS = [
  { title: "This Week", activities: MOCK_THIS_WEEK },
  { title: "Last Week", activities: MOCK_LAST_WEEK },
] as const;
